import { combineReducers } from "@reduxjs/toolkit";
import loaderReducer from "../slices/global/LoaderSlice";
import toastReducer from "../slices/global/ToastSlice";
import walletReducer from "../slices/global/WalletSlice";
import AuthReducer from "../slices/auth/authSlice";
import FilterReducer from "../slices/Filter/filterSlice";
import CollectionNFTFilterReducer from "../slices/Filter/CollectionNFTFilterSlice";
import DashboardFilterReducer from "../slices/Filter/DashboardFilterSlice";
import SearchFilterReducer from "../slices/Filter/SearchFilterSlice";

const rootReducer = combineReducers({
  loader: loaderReducer,
  toast: toastReducer,
  wallet: walletReducer,
  auth: AuthReducer,
  filter: FilterReducer,
  CollectionNFTFilter: CollectionNFTFilterReducer,
  DashboardFilter: DashboardFilterReducer,
  searchFilter: SearchFilterReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
